import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../views/index.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/login',
		name: 'login',
		component: () => import('../views/login/login.vue')
	},
	{
		path: '/',
		name: 'home',
		component: home,
		children: [
			{
				path: '/client/cooperative',
				name: 'cooperative',
				component: () => import('../views/client/cooperative.vue')
			},
			{
				path: '/client/cooperative2',
				name: 'cooperative',
				component: () => import('../views/client/cooperative copy.vue')
			},
			{
				path: '/client/potential',
				name: 'potential',
				component: () => import('../views/client/potential.vue')
			},
			{
				path: '/client/potential2',
				name: 'potential',
				component: () => import('../views/client/potential copy.vue')
			},
			{
				path: '/supplier',
				name: 'supplier',
				component: () => import('../views/supplier/supplier.vue')
			},
			{
				path: '/supplier2',
				name: 'supplier',
				component: () => import('../views/supplier/supplier copy.vue')
			},
			{
				path: '/material',
				name: 'material',
				component: () => import('../views/material/material.vue')
			},
			{
				path: '/material/upstream',
				name: 'upstream',
				component: () => import('../views/material/upstream.vue')
			},
			{
				path: '/material/upstream2',
				name: 'upstream',
				component: () => import('../views/material/upstream copy.vue')
			},
			{
				path: '/material/downstream',
				name: 'downstream',
				component: () => import('../views/material/downstream.vue')
			},
			{
				path: '/material/downstream2',
				name: 'downstream',
				component: () => import('../views/material/downstream copy.vue')
			},
			{
				path: '/recycler',
				name: 'recycler',
				component: () => import('../views/recycler/recycler.vue')
			},
			{
				path: '/recycler2',
				name: 'recycler',
				component: () => import('../views/recycler/recycler copy.vue')
			},
			{
				path: '/service',
				name: 'service',
				component: () => import('../views/service/service.vue')
			},
			{
				path: '/cooperation-intents',
				name: 'CooperationIntents',
				component: () => import('../views/cooperation-intents/index.vue')
			}
		]
	},
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
})

// 导航守卫：使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
// router.beforeEach((to, from, next) => {
// 	if (to.path === '/login') {
// 		next();
// 	} else {

// 		let token = localStorage.getItem("token");

// 		if (!token) {
// 			console.log('未登录')
// 			next('/login');
// 		} else {
// 			next();
// 		}
// 	}
// });


// 避免了到当前位置的冗余导航
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location)
}

export default router
